import React from "react";

import { GifType, Wrangler } from "@/components/ui/Wrangler";

export const LoadingState: React.FC = () => (
  <Wrangler variant={GifType.Searching} size="sm" className="px-4 py-12" />
);
